export const mobilecheck = () => {
  return typeof window.orientation !== 'undefined'
}
